import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import Header from '../../components/Header/Header';
import { back } from '../../actions/routing';
import { loadTermsAndConditionsEmma, loadPICSEmma } from '../../redux/modules/signup';
import { TERMS_CONST } from '../../constants/constants';
import './tnc.scss';

export class TermsAndConditions extends Component {
  static propTypes = {
    description: PropTypes.array.isRequired,
    // descriptionEmma: PropTypes.array.isRequired,
    // loadTermsAndConditions: PropTypes.func.isRequired,
    loadTermsAndConditionsEmma: PropTypes.func.isRequired,
    back: PropTypes.func.isRequired,
    // loadPICS: PropTypes.func.isRequired,
    loadPICSEmma: PropTypes.func.isRequired,
    routeParams: PropTypes.object.isRequired,
  };

  componentDidMount() {
    if (this.props.routeParams.token === TERMS_CONST.terms) {
      this.props.loadTermsAndConditionsEmma();
    } else if (this.props.routeParams.token === TERMS_CONST.pics) {
      this.props.loadPICSEmma();
    } else if (this.props.route.path === "privacy-policy") {
      this.props.loadPICSEmma();
    } else if (this.props.route.path === "terms-and-conditions") {
      this.props.loadTermsAndConditionsEmma();
    } else {
      this.props.back();
    }
  }

  render() {
    const { description } = this.props;
    return (
      <div className="tnc-container">
        <Header />
        {/* <div className="close-btn" onClick={this.props.back} /> */}
        <div className="tnc-content">
          {description.map(({ text, type }) => {
            if (type === 'html') {
              return ReactHtmlParser(text);
            }

            return <p key={text}>{ReactHtmlParser(text)}</p>;
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    description: state.signup.description,
  };
};

export default connect(mapStateToProps, { loadTermsAndConditionsEmma, back, loadPICSEmma })(TermsAndConditions);
